import {CHANGE_PRIMARY_COLOR, CHANGE_THEME} from "../actions/types";
import {useSelector} from "react-redux";
import {primaryColors} from "../../constants/colorScheme";

const INITIAL_STATE = {
    theme: localStorage.getItem("theme") || 'light',
    darkMode: localStorage.getItem("theme") === 'dark',
    primaryColor: localStorage.getItem("primaryColor") || primaryColors[0].value
};

export default function themeReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case CHANGE_PRIMARY_COLOR: return {
            ...state,
            primaryColor: action.payload
        };
        case CHANGE_THEME: return {
            ...state,
            darkMode: action.payload === 'dark',
            theme: action.payload
        };
        default:
            return state;
    }
}

export const useThemeSelector = () =>
    useSelector(themeSelector());

export const themeSelector = () => state => state.theme;

export const darkMode = () => state => state.theme.darkMode;